import GedTagRepository from '@/shared/http/repositories/business/gedtag'
import ActionsForm from '@/shared/mixins/actionsForm'
import gedTagModel from '@/shared/models/business/gedtagmodel'
import { loading } from '@/shared/utils/UIHelper'
import addTagForm from './addtag-form'

export default {
  name: 'AddTag',
  mixins: [ActionsForm],
  data () {
    return {
      data: gedTagModel,
      form: addTagForm
    }
  },
  created () {
    this.onClear()
  },
  methods: {
    onLoad () {
      loading.push()
      GedTagRepository.GetAll()
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(err => this.onException(err))
    },
    onCreate () {
      loading.push()
      GedTagRepository.Create(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onUpdate () {
      loading.push()
      this.data.status = parseInt(this.data.status)
      GedTagRepository.Update(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onDelete (obj) {
      loading.push()
      GedTagRepository.Delete(obj.id)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/tag/addtag.js